const PAYMENT_ACCEPTANCE = [
    {
        label: 'Accepted',
        value: 'ACCEPTED'
    },
    {
        label: 'Rejected',
        value: 'REJECTED'
    },
    {
        label: 'Pending',
        value: 'PENDING'
    }
];

export { PAYMENT_ACCEPTANCE };